import * as React from "react";
import { UserPrescriptionModel } from '../../../models/user/userPrescriptionModel';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import AuthService from '../../../services/authService';
import { enumToDropdownArray, getFrequencyCounterLabel, fomatDateAsString, fomatTimeAsString, fomatDateTimeAsString, getNotificationSummary, formatAlarmTime } from '../../../common/functions/helperFunctions';
import * as HelperFunctions from "../../../common/functions/helperFunctions";
import { DatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import Growl from '../../../common/components/alertMessage/growl';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';

interface IProps {
  //history: any,
  saveClick: any,
  cancelClick: any,
  isVisible: boolean,
  currentUserPrescription: UserPrescriptionModel
}

interface IState {
  isLoading: boolean;
  validationMessage: string;
  userId: number;
  userPrescription: UserPrescriptionModel
}

class UserPrescriptionAddEditDialog extends React.Component<IProps, IState> {
  authService = new AuthService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      validationMessage: '',
      isLoading: false,
      userId: props.currentUserPrescription.userId,
      userPrescription: props.currentUserPrescription
    };
  }

  componentDidMount() {
  }

  handleSaveButton = (event, close) => {
    event.preventDefault();
    const userPrescription = this.state.userPrescription;

    if (userPrescription.startDate) {
      userPrescription.startDate = HelperFunctions.fomatDateAsString(new Date(userPrescription.startDate))
    } else {
      userPrescription.startDate = HelperFunctions.fomatDateAsString(new Date())
    }

    if (userPrescription.endDate) {
      userPrescription.endDate = HelperFunctions.fomatDateAsString(new Date(userPrescription.endDate))
    } else {
      userPrescription.endDate = HelperFunctions.fomatDateAsString(HelperFunctions.getDayslater(new Date().toString(), 7))
    }

    if (userPrescription.endDate) {
      userPrescription.endDate = fomatDateAsString(new Date(userPrescription.endDate));

      if (userPrescription.endDate < userPrescription.startDate) {
        this.growl.show({ severity: 'error', summary: Translate("Start date is greater than end date") });
        return;
      }
    }

    this.props.saveClick(userPrescription, close);
  }

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  handleChange = (key, value) => {
    const userPrescription: UserPrescriptionModel = { ...this.state.userPrescription };
    userPrescription[key] = value;
    this.setState({ userPrescription: { ...userPrescription } });
  };


  public render() {
    const { isLoading, userPrescription } = this.state;

    let dialogHeader: string = Translate('Doctors prescription');

    return (
      <>
        <Dialog
          open={this.props.isVisible}
          onClose={this.handleCancelButton}
          fullWidth
        >
          <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{dialogHeader}</Modal.DialogTitle>
          <Modal.DialogContent>
            <div>
              <Growl ref={(el) => this.growl = el} />
              {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}

              <div className="p-grid p-fluid p-md-12">
                <Card className="prescription-card">
                  <CardContent>
                    <h2 style={{ margin: 0 }}>{Translate('Prescription')}</h2>
                    <div className="p-col-12 p-md-6">
                      <DatePicker
                        format={Translate('DateFormat')}
                        margin="normal"
                        label={Translate('Start date course of treatment')}
                        value={userPrescription.startDate ? new Date(userPrescription.startDate) : new Date()}
                        onChange={(e) => this.handleChange('startDate', e)}
                      />
                    </div>
                    <div className="p-col-12 p-md-6">
                      <DatePicker
                        format={Translate('DateFormat')}
                        margin="normal"
                        label={Translate('End date course of treatment')}
                        value={userPrescription.endDate ? new Date(userPrescription.endDate) : HelperFunctions.getDayslater(new Date().toString(), 7)}
                        onChange={(e) => this.handleChange('endDate', e)}
                      />
                    </div>
                    <div className="p-col-12 p-md-12">
                      <TextField
                        autoComplete="off"
                        id="doctor"
                        label={Translate('Doctor')}
                        value={userPrescription && userPrescription.doctor ? userPrescription.doctor : ""}
                        onChange={(e) => this.handleChange('doctor', e.target['value'])}
                        margin="none"
                      />
                    </div>
                    <div className="p-col-12 p-md-12">
                      <TextField
                        autoComplete="off"
                        id="hospital"
                        label={Translate('Hospital')}
                        value={userPrescription && userPrescription.hospital ? userPrescription.hospital : ""}
                        onChange={(e) => this.handleChange('hospital', e.target['value'])}
                        margin="none"
                      />
                    </div>
                  </CardContent>
                </Card>
                <Card className="prescription-card">
                  <CardContent>
                    <h2 style={{ margin: 0 }}>{Translate('Diet')}</h2>
                    <div className="p-col-12 p-md-12">
                      <TextField
                        autoComplete="off"
                        id="recommendedFoods"
                        label={Translate('Recommended food and drinks')}
                        value={userPrescription && userPrescription.recommendedFoods ? userPrescription.recommendedFoods : ""}
                        onChange={(e) => this.handleChange('recommendedFoods', e.target['value'])}
                        margin="none"
                      />
                    </div>
                    <div className="p-col-12 p-md-12">
                      <TextField
                        autoComplete="off"
                        id="notAllowedFoods"
                        label={Translate('Not allowed food and drinks')}
                        value={userPrescription && userPrescription.notAllowedFoods ? userPrescription.notAllowedFoods : ""}
                        onChange={(e) => this.handleChange('notAllowedFoods', e.target['value'])}
                        margin="none"
                      />
                    </div>
                  </CardContent>
                </Card>
                <Card className="prescription-card">
                  <CardContent>
                    <h2 style={{ margin: 0 }}>{Translate('Life mode')}</h2>
                    <div className="p-col-12 p-md-12">
                      <TextField
                        autoComplete="off"
                        id="recommendedTreatment"
                        label={Translate('Treatment recommendations')}
                        value={userPrescription && userPrescription.recommendedTreatment ? userPrescription.recommendedTreatment : ""}
                        onChange={(e) => this.handleChange('recommendedTreatment', e.target['value'])}
                        margin="none"
                      />
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </Modal.DialogContent>
          <Modal.DialogActions>
            <div>
              <Button variant="contained" size="small" onClick={this.handleCancelButton} style={{ marginRight: '10px' }}>
                <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                {Translate('Cancel')}
              </Button>
              <Button variant="contained" size="small" color="primary" onClick={(e) => this.handleSaveButton(e, true)}
                disabled={!userPrescription || !userPrescription.doctor || userPrescription.doctor.trim() == ''}>
                <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
                {Translate('Save')}
              </Button>
            </div>
          </Modal.DialogActions>
        </Dialog>
      </>
    )
  }
}

export default UserPrescriptionAddEditDialog;